import React, { useEffect, useRef, useState } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import {
  REPORT_TYPES,
  TWITTERLEGENDS,
} from "../../../../constants/app-constant";
import { getSocialPlatformIdFromName } from "../../../../utility/common-methods";

const {
  JournalistNOARanking,
  JournalistAnalysisPrint,
  JournalistNOATrend,
  SOV_NOA_TREND,
  JournalistTonalityNOARanking,
  PublicationNOATrend,
  TonalityNAORanking,
  PublicationNOARanking,
  PublicationTonalityNOARanking,
  CityWiseNOARanking,
  CityWiseNOATrend,
  CityWiseTonality,
  CityWiseCCMTonality,
  CityWiseMAVTonality,
  CityWiseCCMRanking,
  PLATFORM_TONALITY,
  PLATFORM_TREND,
  PLATFORM_RANK,
  Reach,
  TonalityNAOTrend,
  TonalityWCTrend,
  CitySpecificReport,
  TonalityWordCount,
  TagBasedTagAnalysis,
  EntityBasedTagAnalysis,
  EditionWiseNOATrend,
  MediaWiseNOARanking,
  ThematicAnalysisTag,
  ThematicAnalysisEntity,
} = REPORT_TYPES;

const formatData = ({ datasets }) => {
  if (!datasets) return;
  return datasets.map((elm) => ({
    name: elm.label,
    data: elm.data && elm.data.map((el) => parseInt(el)),
    color: elm.backgroundColor,
  }));
};
const formatTwitterData = (data) => {
  if (!data) return;
  return TWITTERLEGENDS.map(({ name, color, entityname }) => {
    const newArray = data.map((x) => {
      const array = Object.keys(x).filter((el, index) => el == entityname);
      return parseInt(x[array]);
    });
    return {
      name: name,
      data: newArray,
      color: color,
    };
  });
};
export const StackedBarChartHCEqualHeight = function ({
  graphApiResponse = { hcData: [{}] },
  onEntityClick,
  reportType,
  entityList,
  dataByReportType,
  editionList,
  isEmbededWidget,
  chartTitle,
  setGraphRef,
  setGraphRefList,
  mediaType,
  data,
  twitterFeeds,
}) {


  const labels = data && data.length && data.map(({ date }) => date);
  const [lineChartData, setLineChartData] = useState({});
  const ref = useRef();
  useEffect(() => {
    setGraphRef(ref);
  }, []);

  useEffect(() => {
    if (graphApiResponse?.datasets) {
      redrawChart();
    }
  }, [graphApiResponse]);

  useEffect(() => {
    // redrawChart();
  }, [data]);

  const redrawChartOld = () => {
    const options = {
      chart: {
        type: "column",
      },
      title: {
        text: chartTitle,
        margin: 10,
        style: {
          fontSize: "12px",
          fontWeight: "bold",
          color: "#666",
        },
      },
      exporting: {
        sourceWidth: 1200,
        chartOptions: {
          plotOptions: {
            series: {
              pointWidth: 50,
            },
          },
          legend: {
            enabled: true,
            verticalAlign: "top",
            maxHeight: 1000,
            margin: 25,
            y: 70,
          },
        },
      },
      series: !twitterFeeds
        ? formatData(graphApiResponse)
        : formatTwitterData(data),
      plotOptions: {
        column: {
          stacking: "normal",
          dataLabels: {
            enabled: true,
          },
        },
        series: {
          events: {
            click: (e) => handleBarClick(e),
          },
        },
      },
      xAxis: {
        categories: !twitterFeeds ? graphApiResponse.labels : labels,
        labels: {
          style: {
            fontSize: "8px",
            textOverflow: "none",
          },
        },
      },
      yAxis: {
        title: {
          text: null,
        },
      },
    };
    setLineChartData(options);
  };

  const redrawChart = () => {
    let graphData = !twitterFeeds
      ? formatData(graphApiResponse)
      : formatTwitterData(data);
    const sumArray = [];

    for (let ele of graphData) {
      if (ele.data) {
        ele.data.forEach((val, ind) => {
          sumArray[ind] = (sumArray[ind] || 0) + val;
        });
      }
    }

    graphData = graphData.map((ele) => {
      ele.data = ele.data
        ? ele.data.map((val, ind) => {
          const percentVal = +((val * 100) / sumArray[ind]);
          return percentVal || 0;
          // return +((val * 100) / sumArray[ind]).toFixed(3);
        })
        : ele.data;
      return ele;
    });

    const options = {
      chart: {
        type: "column",
      },
      title: {
        text: chartTitle,
        margin: 10,
        style: {
          fontSize: "12px",
          fontWeight: "bold",
          color: "#666",
        },
      },
      series: graphData,
      plotOptions: {
        column: {
          stacking: "normal",
          dataLabels: {
            enabled: true,
          },
        },
        series: {
          dataLabels: {
            enabled: true,
            // format: "{(y).toFixed(2)}",
            formatter: function () {
              return this.point.y.toFixed(2);
            },
          },
          tooltip: {
            valueDecimals: 2,
          },
          events: {
            click: (e) => handleBarClick(e),
          },
        },
      },
      xAxis: {
        categories: !twitterFeeds ? graphApiResponse.labels : labels,
        labels: {
          style: {
            fontSize: "8px",
            textOverflow: "none",
          },
        },
      },
      yAxis: {
        tickPositions: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        // min: 0,
        // max: 100,
        // tickInterval: 10,
        // alignTicks: false,
        title: {
          text: null,
        },
        labels: {
          format: "{value} %",
        },
      },
    };
    setLineChartData(options);
    if (setGraphRefList) {
      setGraphRefList(reportType + mediaType, ref);
    }
  };

  const handleBarClick = (e) => {
    try {
      const {
        point: {
          category,
          series: { name },
        },
      } = e;
      const [label, legend] = [category, name];
      let routeParams = {
        entityId: null,
        vertical: null,
        date: null,
      };
      let clickedEntity = label;
      if (
        // /entity/i.test(reportType) &&
        /tonality/i.test(reportType) &&
        /sov/i.test(reportType)
      ) {
        routeParams.tonality = legend;
        if (/publication/i.test(reportType)) {
          routeParams.publication = label;
        }
        if (/journalist/i.test(reportType)) {
          routeParams.sourceName = label;
        }
        if (/city/i.test(reportType)) {
          routeParams.edition = label;
        }
        if (/keyword/i.test(reportType)) {
          routeParams.keyword = label;
        }
      }
      if (
        /^journalist/i.test(reportType) &&
        (/sov/i.test(reportType) ||
          /tonality/i.test(reportType)) &&
        (/entity/i.test(reportType) ||
          /keyword/i.test(reportType))
      ) {
        console.log('Journalist SOV/Tonality');
        clickedEntity = label;
        if (/sov/i.test(reportType)) {
          if (/keyword/i.test(reportType)) routeParams.keyword = legend;
          if (/entity/i.test(reportType)) routeParams.sourceName = legend;
        } else {
          if (/keyword/i.test(reportType)) routeParams.keyword = legend;
          if (/entity/i.test(reportType)) routeParams.tonality = legend;
        }
      }
      if (
        (/ranking/i.test(reportType) &&
          /sov/i.test(reportType))
      ) {
        if (/publication/i.test(reportType))
          routeParams.publication = legend;
        if (/journalist/i.test(reportType))
          routeParams.sourceName = legend;
        if (/city/i.test(reportType))
          routeParams.edition = legend;
        if (/keyword/i.test(reportType))
          routeParams.keyword = legend;
      }
      if (
        /geolocation/i.test(reportType) &&
        /sov/i.test(reportType)
      ) {
        console.log("geolocation category");
        if (/publication/i.test(reportType)) {
          routeParams.publication = label;
          routeParams.zone = legend
        } else if (/keyword/i.test(reportType)) {
          routeParams.keyword = label;
          routeParams.zone = legend;
        } else {
          if (mediaType === 1) {
            routeParams.edition = legend;
            routeParams.media_type = 2;
          } else {
            routeParams.zone = legend;
          }
        }
      }
      if (/trend/i.test(reportType)) {
        routeParams.date = label;
        if (
          /geolocation/i.test(reportType) &&
          /entity/i.test(reportType)
        ) {
          if (mediaType === 1) {
            routeParams.edition = legend;
            routeParams.media_type = 2;
          } else {
            clickedEntity = legend;
          }
        }
        if (/^geolocation/i.test(reportType) && !/entity/i.test(reportType)) {
          console.log("Geolocation trend category");
          if (/publication/i.test(reportType)) {
            routeParams.publication = legend;
          }
          if (/keyword/i.test(reportType)) {
            routeParams.keyword = legend;
          }
        }
        if (
          /^journalist/i.test(reportType) &&
          (/entity/i.test(reportType) ||
            /keyword/i.test(reportType))
        ) {
          console.log("journalist trend category");
          if (/keyword/i.test(reportType)) {
            routeParams.keyword = legend;
          }
          if (/entity/i.test(reportType)) {
            clickedEntity = legend;
          }
        }
      }
      if (
        /^geolocation/i.test(reportType) &&
        /tonality/i.test(reportType)
      ) {
        console.log("Geolocation Tonality category");
        if (/publication/i.test(reportType)) {
          routeParams.publication = legend;
        } else if (/keyword/i.test(reportType)) {
          routeParams.keyword = legend;
        } else {
          if (mediaType === 1) {
            routeParams.edition = legend;
            routeParams.media_type = 2;
          } else {
            routeParams.tonality = legend;
          }
        }
      }
      if (
        /^publication/i.test(reportType) &&
        (
          /SOV/.test(reportType) ||
          /Tonality/.test(reportType) ||
          /Trend/.test(reportType)
        ) &&
        (
          /Entity/.test(reportType) ||
          /Keyword/.test(reportType) ||
          /Journalist/.test(reportType)
        )
      ) {
        console.log("Publication category");
        routeParams.publication = legend;
        if (/Entity/.test(reportType)) {
          clickedEntity = label;
          if (/Trend/.test(reportType)) {
            clickedEntity = legend;
          }
        }
        if (/Keyword/.test(reportType)) {
          routeParams.keyword = label;
          if (/Trend/.test(reportType)) {
            routeParams.keyword = legend;
          }
        }
        if (/Journalist/.test(reportType)) {
          routeParams.sourceName = label;
          if (/Trend/.test(reportType)) {
            routeParams.sourceName = legend;
          }
        }
      }
      if (/^Thematic/.test(reportType)) {
        console.log("Thematic category");
        clickedEntity = label;
        if (/Entity/.test(reportType)) {
          if (/Trend/.test(reportType))
            clickedEntity = legend;
          else if (/Tonality/.test(reportType))
            routeParams.tonality = legend;
          else
            routeParams.theme = legend;
        }
        else if (/City/.test(reportType)) {
          routeParams.edition = legend;
        }
        else if (/Publication/.test(reportType)) {
          routeParams.publication = legend;
        }
        else if (/Journalist/.test(reportType)) {
          console.log('source name changed thematic');
          routeParams.sourceName = legend;
        }
        else if (/Keyword/.test(reportType)) {
          routeParams.keyword = legend;
        }
      }
      if (/^Keyword/.test(reportType)) {
        console.log("Keyword category");
        clickedEntity = label;
        if (/Entity/.test(reportType)) {
          if (/Trend/.test(reportType))
            clickedEntity = legend;
          else if (/Tonality/.test(reportType))
            routeParams.tonality = legend;
          else
            routeParams.keyword = legend;
        }
        else if (/City/.test(reportType)) {
          routeParams.edition = legend;
        }
        else if (/Publication/.test(reportType)) {
          routeParams.publication = legend;
        }
        else if (/Journalist/.test(reportType)) {
          routeParams.sourceName = legend;
        }
        else if (/Spokesperson/.test(reportType)) {
          routeParams.spokesperson = legend;
        }
      }
      if (/^Sentiment/.test(reportType)) {
        console.log("Sentiment category");
        if (/Entity/.test(reportType)) {
          clickedEntity = label;
          routeParams.tonality = legend;
          routeParams.tonalityConditon = true;
        } else if (/City/.test(reportType)) {
          routeParams.edition = legend;
        }
        else if (/Publication/.test(reportType)) {
          routeParams.publication = legend;
        }
        else if (/Journalist/.test(reportType)) {
          routeParams.sourceName = legend;
        }
        else if (/Keyword/.test(reportType)) {
          routeParams.keyword = legend;
        }
      }
      if (/^Spokesperson/.test(reportType)) {
        console.log("Spokesperson category");
        const trend = /Trend/.test(reportType);
        if (/Entity/.test(reportType)) {
          clickedEntity = label;
          if (trend) clickedEntity = legend;
          else routeParams.spokesperson = legend;
        }
        else if (/Profile/.test(reportType)) {
          routeParams.profile = legend;
        }
        else if (/Journalist/.test(reportType)) {
          routeParams.sourceName = legend;
        }
        else if (/Topic/.test(reportType)) {
          routeParams.topic = legend;
        }
      }
      // if (reportType == CitySpecificReport) {
      //   routeParams.keyword = legend;
      // }
      // switch (reportType) {
      //   case EntityBasedTagAnalysis:
      //     routeParams.tagFilterName = legend;
      //     break;

      //   case TagBasedTagAnalysis:
      //     routeParams.tagFilterName = label;
      //     break;
      // }

      // if (
      //   reportType === SOV_NOA_TREND ||
      //   reportType === JournalistNOARanking ||
      //   reportType === JournalistNOATrend ||
      //   reportType === JournalistAnalysisPrint ||
      //   reportType === PublicationNOARanking ||
      //   reportType === PublicationNOATrend ||
      //   reportType === CityWiseNOATrend ||
      //   reportType === PLATFORM_RANK ||
      //   reportType === PLATFORM_TREND ||
      //   reportType === TonalityNAOTrend ||
      //   reportType === TonalityWCTrend ||
      //   reportType === MediaWiseNOARanking ||
      //   reportType === ThematicAnalysisTag ||
      //   reportType === TagBasedTagAnalysis
      // ) {
      //   clickedEntity = legend;
      // }
      // if (
      //   reportType === SOV_NOA_TREND ||
      //   reportType === JournalistNOATrend ||
      //   reportType === JournalistAnalysisPrint ||
      //   reportType === PublicationNOATrend ||
      //   reportType === CityWiseNOATrend ||
      //   reportType === TonalityNAOTrend ||
      //   reportType === EditionWiseNOATrend ||
      //   reportType === TonalityWCTrend ||
      //   twitterFeeds
      // ) {
      //   routeParams.date = label;
      // }
      // if (reportType === JournalistNOARanking) {
      //   routeParams.sourceName = label;
      //   if (isEmbededWidget) {
      //     let labelArray = label.split("[");
      //     routeParams.sourceName = labelArray
      //       .slice(0, labelArray.length - 1)
      //       .join("[");
      //   }
      // }
      // if (reportType === JournalistAnalysisPrint) {
      //   routeParams.sourceName = clickedEntity;
      // }
      // if (reportType === PublicationNOARanking) {
      //   const clickedPublication = dataByReportType.filter(
      //     (elm) => elm.publication_name == label
      //   )[0];
      //   routeParams.publication = clickedPublication;
      // }
      // if (reportType === ThematicAnalysisTag) {
      //   const clickedCategory = dataByReportType.filter(
      //     (elm) => elm.category_name == label
      //   )[0];
      //   routeParams.categoryId = clickedCategory.category_id;
      // }
      // if (reportType === ThematicAnalysisEntity) {
      //   const entityClicked = dataByReportType.filter(
      //     (elm) => elm.entity_name == label
      //   )[0];

      //   if (entityClicked && entityClicked.data && entityClicked.data.length) {
      //     const clickedCategory = entityClicked.data.filter(
      //       (elm) => elm.category_name == legend
      //     )[0];
      //     routeParams.categoryId = clickedCategory.category_id;
      //   }
      // }
      // if (reportType == REPORT_TYPES.SOV || reportType === PLATFORM_TREND) {
      //   routeParams.date = label;
      // }
      // if (
      //   reportType === CityWiseNOARanking ||
      //   reportType === EditionWiseNOATrend ||
      //   reportType === CityWiseCCMRanking
      // ) {
      //   const clickedEdition = editionList.filter(
      //     (elm) => elm.edition_name == legend
      //   )[0];
      //   routeParams.edition = clickedEdition;
      // }
      // if (reportType === MediaWiseNOARanking) {
      //   const clickedEdition = editionList.filter(
      //     (elm) => elm.edition_name == label
      //   )[0];
      //   routeParams.edition = clickedEdition;
      // }
      // if (
      //   reportType === JournalistTonalityNOARanking ||
      //   reportType === TonalityNAORanking ||
      //   reportType === PublicationTonalityNOARanking ||
      //   reportType === CityWiseTonality ||
      //   reportType === CityWiseCCMTonality ||
      //   reportType === CityWiseMAVTonality ||
      //   reportType === TonalityWordCount ||
      //   reportType === PLATFORM_TONALITY
      // ) {
      //   const tone = legend;
      //   routeParams.tonality = tone;
      // }
      // if (reportType == PLATFORM_RANK) {
      //   routeParams.channelType = getSocialPlatformIdFromName(label);
      // }
      // if (reportType == Reach) {
      //   routeParams.channelType = getSocialPlatformIdFromName(legend);
      // }
      let entity =
        entityList &&
        entityList.filter(
          (elm) =>
            clickedEntity == elm.entity_name?.trim() ||
            clickedEntity == elm.name
        )[0];
      routeParams.entityId = entity && entity.id.toString();
      // console.log(routeParams.entityId);
      onEntityClick(e, routeParams);
    } catch (e) {
      onEntityClick(e, {});
    }
  };

  return (
    <div className={isEmbededWidget ? "biggerWidget" : ""}>
      <HighchartsReact
        highcharts={Highcharts}
        options={lineChartData}
        ref={ref}
      />
    </div>
  );
};

StackedBarChartHCEqualHeight.defaultProps = {
  graphApiResponse: {},
  onEntityClick: () => { },
  reportType: "",
  entityList: [],
  dataByReportType: {},
  editionList: [],
  isEmbededWidget: false,
  chartTitle: "",
  setGraphRef: () => { },
  setGraphRefList: () => { },
};
